import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import Description$1 from './Description.js';
import { getContactLensFeatures } from '../../utils/get-contactlens-features.js';

const DescriptionContainer = ({ colorFeatureIcons , specificationVariant , variant , specificationConfiguration ,  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            description: variant.description,
            header: variant.header
        })
    , [
        getLabel,
        variant
    ]);
    const { productFeatures , lensFeatures  } = React.useMemo(()=>getContactLensFeatures(variant, getLabel)
    , [
        getLabel,
        variant
    ]);
    return /*#__PURE__*/ React.createElement(Description$1, {
        colorFeatureIcons: colorFeatureIcons,
        labels: labels,
        lensFeatures: lensFeatures,
        productFeatures: specificationConfiguration || productFeatures,
        specificationVariant: specificationVariant
    });
};
var Description = DescriptionContainer;

export { Description as default };
//# sourceMappingURL=DescriptionContainer.js.map
